export const freeze = Object.freeze

function freezeObj(obj, freezer, maxDepth) {
  for (const name of Reflect.ownKeys(obj)) {
    const value = obj[name]
    if (value && typeof value === 'object') {
      // max maxDepth
      if (maxDepth !== undefined && maxDepth > 0) {
        freezer(value, maxDepth - 1)
      } else {
        Object.freeze(value)
      }
    }
  }
  return Object.freeze(obj)
}

export function shallowFreeze(object) {
  return freezeObj(object, Object.freeze)
}

// dangerous because you can over-do it into things you didn't expect, like
// if window is included, or if you have cross-linked objects(recursive)
export function deepFreeze(object, maxDepth = undefined) {
  return freezeObj(object, deepFreeze, maxDepth)
}
